import type { WaitlistForm } from '../types/waitlist';

const TOTAL_STEPS = 3;

/** Field labels for user-facing error messages */
export function getMissingFieldsForStep(
  step: number,
  form: WaitlistForm
): string[] {
  const missing: string[] = [];
  switch (step) {
    case 1:
      if (!form.name.trim()) missing.push('Name');
      if (!form.email.trim()) missing.push('Email');
      if (!form.company.trim()) missing.push('Company');
      if (!form.role.trim()) missing.push('Role');
      break;
    case 2:
      if (!form.companyType.trim()) missing.push('Company type');
      if (!form.companySize.trim()) missing.push('Company size');
      if (!form.headquarters.trim()) missing.push('Headquarters');
      break;
    case 3:
      if (form.trialPhase.length === 0) missing.push('At least one trial phase');
      if (form.therapeuticAreas.length === 0) missing.push('At least one therapeutic area');
      if (form.targetCountries.length === 0) missing.push('At least one country');
      if (!form.expectedTrials.trim()) missing.push('Expected trials per year');
      if (!form.timeframe.trim()) missing.push('Timeframe to start');
      break;
    default:
      break;
  }
  return missing;
}

export function isWaitlistFormComplete(form: WaitlistForm): boolean {
  for (let s = 1; s <= TOTAL_STEPS; s += 1) {
    if (getMissingFieldsForStep(s, form).length > 0) return false;
  }
  return true;
}

/** All missing required labels, prefixed by step (for logs and clearer errors). */
export function getAllMissingFieldsWithSteps(form: WaitlistForm): string[] {
  const acc: string[] = [];
  for (let s = 1; s <= TOTAL_STEPS; s += 1) {
    getMissingFieldsForStep(s, form).forEach((label) => {
      acc.push(`Step ${s}: ${label}`);
    });
  }
  return acc;
}

export function getWaitlistTotalSteps(): number {
  return TOTAL_STEPS;
}
